
import { PropType, defineComponent } from 'vue'
import { ClientApi } from '@/types/client-api'

import RegisterNetwork from './form/RegisterNetwork.vue'

export interface NetworksFormState {
  name: string
  networkConfigs: ClientApi.Network[]
  clientNameError?: string
  seriesOptions: Record<string, unknown>
  evenOptions: number[]
  loaded: boolean
  lastIndex: number
  showDeepValidationErrors?: boolean
  planAffiliationNetworkUuids: unknown[]
}

export default defineComponent({
  name: 'client-form',
  components: {
    RegisterNetwork
  },
  props: {
    networks: {
      type: Object as PropType<NetworksFormState>,
      required: true
    }
  }
})
